<template lang="pug" src="./custom-home-slider.pug"></template>

<script>
import ArrowLeft from 'templates/arrow-left.icon.html'
import ArrowRight from 'templates/arrow-right.icon.html'
import Title from 'components/block/block-title/block-title'

export default {
  data () {
    return {
      'arrowLeft': ArrowLeft,
      'arrowRight': ArrowRight
    }
  },
  props: ['props'],
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-slider.vue?6a2322c0